export default class LoadingComponent {
  /**
   *
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    const PROGRESS_BAR_CONFIG = {
      offsetX: 5,
      offsetY: 5,
      width: 300,
      height: 30,
    }

    var progressBar = context.add.graphics()
    var progressBox = context.add.graphics()

    var width = context.cameras.main.width
    var height = context.cameras.main.height

    progressBox.fillStyle(0xfe3188, 0.8)
    progressBox.fillRect(
      width / 2 - PROGRESS_BAR_CONFIG.width / 2 - PROGRESS_BAR_CONFIG.offsetX,
      height / 2 - PROGRESS_BAR_CONFIG.height / 2 - PROGRESS_BAR_CONFIG.offsetY,
      PROGRESS_BAR_CONFIG.width + PROGRESS_BAR_CONFIG.offsetX * 2,
      PROGRESS_BAR_CONFIG.height + PROGRESS_BAR_CONFIG.offsetY * 2
    )

    var loadingText = context.make.text({
      x: width / 2,
      y: height / 2 - 50,
      text: `Estamos escondiendo 
   las palabras`,
      style: {
        font: '20px monospace',
        fill: '#FE4D9C',
      },
    })
    loadingText.setOrigin(0.5, 0.5)

    var percentText = context.make.text({
      x: width / 2,
      y: height / 2,
      text: '0%',
      style: {
        font: '18px monospace',
        fill: '#FFFFFF',
      },
    })
    percentText.setOrigin(0.5, 0.5)

    context.load.on('progress', function (value) {
      if (value < 0.33) {
        loadingText.setText(`Estamos escondiendo 
   las palabras`)
      } else if (value < 0.66) {
        loadingText.setText('Alista tus ojos, respira... ')
      } else if (value < 1) {
        loadingText.setText('¡Prepárate para ganar!')
      }
      percentText.setText(parseInt(value * 100) + '%')
      progressBar.clear()
      progressBar.fillStyle(0xfe9fd1, 1)
      progressBar.fillRect(
        width / 2 - PROGRESS_BAR_CONFIG.width / 2,
        height / 2 - PROGRESS_BAR_CONFIG.height / 2,
        PROGRESS_BAR_CONFIG.width * value,
        PROGRESS_BAR_CONFIG.height
      )
    })

    context.load.on('complete', function () {
      progressBar.destroy()
      progressBox.destroy()
      loadingText.destroy()
      percentText.destroy()
    })
  }
}
